(function (ws) {
    'use strict';
    ws.views.getUsernameModal = ws.views.modal.extend ({
        /**
         * closeModal override - apart from closing the modal, reset inputs and tabs to their initial state
         */
        closeModal: function () {
            this.$('form input').val('');
            this.$('form span').hide();
            ws.views.modal.prototype.closeModal.call(this);
        }
    });
})(westcon);

